import axios from "axios";
import qs from "qs";
import router from "@/router";
import { Message } from "element-ui";
import { baseUrl } from "./configUrl";
// const baseURL = "https://admin.incprog.com/api";
const baseURL = baseUrl;

/**
 * @Description: 对axios的简单封装；
 * @author lipengfei
 * @param
 * @return 返回axios实例；
 * @createTime: 2024-04-23 13:44:23
 * @Copyright by 河南漫云科技有限公司
 */
class Request {
  constructor() {
    Request.getInstance();
    this.requestInterceptors();
    this.responseInterceptors();
  }
  static service;
  static getInstance() {
    if (!Request.service) {
      Request.service = axios.create({
        baseURL,
        timeout: 15000,
      });
    }
    return Request.service;
  }
  // 添加响应拦截器
  responseInterceptors() {
    Request.service.interceptors.response.use(
      (response) => {
        // 对响应数据做点什么
        const res = response.data;
        if (res.code == 1) {
          return response.data;
        } else if (res.code == 401) {
          //做些什么；
          router.push({ path: '/login' });
        }
        return response.data;
      },
      (error) => {
        if (error.response && error.response.data) {
          const res = error.response.data;
          console.error(res, "到error了");
          Message.error(res.msg);
          if (res.code == 401) {
            window.localStorage.removeItem("token");
            window.localStorage.removeItem("user");
            router.push({ path: "/login" });
          }
          return res
        }

        // 对响应错误做点什么
        // return Promise.reject(error);
      }
    );
  }
  // 添加请求拦截器
  requestInterceptors() {
    Request.service.interceptors.request.use(
      (config) => {
        const token = window.localStorage.getItem("token");
        const lang = window.localStorage.getItem("locale");
        if (token) {
          // 需自定义
          // 让每个请求携带token
          config.headers["token"] = token;
        }
        config.headers["lang"] = lang;
        // 在发送请求之前做些什么
        return config;
      },
      (error) => {
        // 对请求错误做些什么
        return Promise.reject(error);
      }
    );
  }
  post(url = "", data = {}) {
    return Request.service.request({
      method: "post",
      url,
      data: qs.stringify(data),
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  get(url = "", data = {}) {
    return Request.service.request({
      method: "get",
      url,
      data,
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    });
  }
}
export default new Request();
